import { render } from "./DegradedServiceBanner.vue?vue&type=template&id=2afd06df&scoped=true&ts=true"
import script from "./DegradedServiceBanner.vue?vue&type=script&lang=ts"
export * from "./DegradedServiceBanner.vue?vue&type=script&lang=ts"

import "./DegradedServiceBanner.vue?vue&type=style&index=0&id=2afd06df&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afd06df"]])

export default __exports__